import { render, staticRenderFns } from "./create.vue?vue&type=template&id=62f55574&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=62f55574&prod&lang=css"
import style1 from "./create.vue?vue&type=style&index=1&id=62f55574&prod&scoped=true&lang=css"
import style2 from "./create.vue?vue&type=style&index=2&id=62f55574&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f55574",
  null
  
)

export default component.exports